import type { NewMalwareScanItem } from "@/_store/endpoint-security/malware-scan.module";
import { OsType } from "@/constants/devices";

export enum MalwareScanActions {
  CREATE = "createMalwareScan",
  EDIT = "editMalwareScan",
  DELETE = "deleteMalwareScan",
}

export const MALWARE_SCAN_FREQUENCY_OPTIONS = [21, 14, 7, 3, 1];

export const defaultMalwareScanItem: NewMalwareScanItem = {
  daysCount: 21,
  osType: OsType.WINDOWS,
  preferredHour: 1,
  labels: [],
};
